import React, { useContext, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoClose } from 'react-icons/io5';
import { BiSupport } from 'react-icons/bi';
import ChatInterface from './ChatInterface';
import { DataContext } from 'context/DataContext';
import Logo from '../../assets/favicon.png';

const ChatbotModal = ({ onClick, isOpen, onClose }) => {
    const { profileData } = useContext(DataContext);

    return (
        <>
            <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={onClick}
                className="fixed bottom-6 right-6 z-40 p-2 lg:p-4 rounded-full animate-bounce shadow-2xl bg-gradient-to-r from-primary to-primary text-black"
            >
                <BiSupport size={28} />
            </motion.button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black/50 z-50 flex items-end justify-end sm:items-center p-4"
                        onClick={(e) => e.target === e.currentTarget && onClose()}
                    >
                        <motion.div
                            className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden flex flex-col h-[85vh] sm:h-[80vh]"
                        >
                            {/* HEADER (FIXED) */}
                            <div className="shrink-0 bg-gradient-to-r from-secondary to-primary text-white p-5 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="rounded-full p-1 bg-gradient-to-r from-primary to-black backdrop-blur flex items-center justify-center">
                                        <img src={Logo} alt="" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg uppercase">{profileData?.Profile?.Project} ChatBot </h3>
                                        <p className="text-sm opacity-90">Here to help you — this is a beta version</p>
                                        </div>
                                </div>
                                <motion.button whileTap={{ scale: 0.9 }} onClick={onClose}>
                                    <IoClose size={28} />
                                </motion.button>
                            </div>

                            {/* CHAT BODY (ONLY THIS CAN SCROLL INTERNALLY) */}
                            <div className="flex-1 min-h-0 flex flex-col bg-gradient-to-b from-gray-50 to-white">
                                <ChatInterface profileData={profileData} />
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default ChatbotModal;